import apiHandler from "../core/apiHandler";

/**
 * 🌍 QZ Tray Client API
 *
 * API base para obtener la configuración completa que necesita el frontend
 * para inicializar la conexión segura con QZ Tray.
 *
 * ✅ Endpoints:
 * - GET /api/qztray/client/config → obtiene host, puerto, SSL, timeout y certificado activo.
 */
const qzTrayClientApi = apiHandler("qztray/client");

export default qzTrayClientApi;
